<template>
    <div class="row">
        <div class="col-12">
            <h2 class="m-0 h1 text-uppercase">{{ $t('partido.completar_datos') }}</h2>
            <div class="subtitle h3 light mb-3 mb-lg-5">
                {{ !reserva_instalaciones ? $t('partido.completa_info') : $t('partido.completa_reserva') }}.
            </div>
            <ValidationObserver tag="form" ref="observer2" @submit.prevent="submit()">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <FormInput
                            v-model="localDatosCompradores.nombre"
                            id="nombre"
                            data-cy="nombre"
                            rules="required"
                            :disabled="desactivar"
                            :label="$t('formularios.nombre')"
                            :name="$t('formularios.nombre')"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <FormInput
                            v-model="localDatosCompradores.apellidos"
                            id="apellidos"
                            data-cy="apellidos"
                            rules="required"
                            :disabled="desactivar"
                            :label="$t('formularios.apellidos')"
                            :name="$t('formularios.apellidos')"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <DocumentoTipo
                            id="tipo-documento-comprador"
                            :value="localDatosCompradores.tipoDocumentoSeleccionado.type"
                            :index="0"
                            :disabled="desactivar"
                            @input="val => { localDatosCompradores.tipoDocumentoSeleccionado.type = val; }"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <DocumentoValor
                            :type="localDatosCompradores.tipoDocumentoSeleccionado.type"
                            :value="localDatosCompradores.dni"
                            :index="0"
                            :disabled="desactivar"
                            @input="val => { localDatosCompradores.dni = val; localDatosCompradores.tipoDocumentoSeleccionado.value = val; }"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <FormInput
                            v-model="localDatosCompradores.email"
                            id="email"
                            data-cy="email"
                            vid="confirmation"
                            rules="required|email"
                            :infoText="disabledEmailPreventa ? 'No puedes modificar el email en la preventa' : null"
                            :disabled="desactivar || disabledEmailPreventa"
                            :label="$t('formularios.email')"
                            :name="$t('formularios.email')"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <FormInput
                            v-model="localDatosCompradores.email_confirmation"
                            id="email_confirmation"
                            data-cy="email_confirmation"
                            :rules="'required|confirmed_ci:@confirmation'"
                            :disabled="desactivar || disabledEmailPreventa"
                            :label="$t('formularios.confirmar_email')"
                            :name="$t('formularios.confirmar_email')"
                        />
                    </div>
                    <DateInput
                        v-model="localDatosCompradores.fecha_nacimiento"
                        id="fecha_nacimiento"
                        wrapperClass="col-12 col-lg-6"
                        dataCy="fecha-nacimiento"
                        :label="$t('formularios.nacimiento')"
                        :name="$t('formularios.nacimiento')"
                        :disabled="desactivar"
                    />
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label>{{ $t('formularios.telefono') }}</label>
                            <PhoneInput
                                id="telefono-comprador"
                                :phone="localDatosCompradores.telefono ?? null"
                                :desactivar="desactivar"
                                :forceValidate="false"
                                dataCy="telefono"
                                @setNumber="(number) => localDatosCompradores.telefono = number"
                                @validNumber="(valid) => isValidNumber = valid"
                            />
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <FormInput
                            v-model="localDatosCompradores.cp"
                            id="cp"
                            data-cy="cp"
                            rules="required"
                            :disabled="desactivar"
                            :label="$t('formularios.cp')"
                            :name="$t('formularios.cp')"
                        />
                    </div>
                    <template v-if="fields && fields.length > 0">
                        <div v-for="(field, index) in fields" :key="index" :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-6' : '')">
                            <FieldComponent
                                :field="field"
                                :desactivar="desactivar"
                                v-model="localDatosCompradores.properties[field.name]"
                            />
                        </div>
                    </template>
                    <template v-if="errors">
                        <div class="col-11 alert alert-danger m-auto" style="margin-bottom: 15px !important;" v-for="(error, index) in errors" :key="index" id="errors">
                            <ul class="p-1 m-0">
                                <li><b>{{ 'El campo ' + error.message }}</b></li>
                            </ul>
                        </div>
                    </template>
                    <div class="col-12">
                        <div v-if="!reserva_instalaciones">
                            <p class="h4 text-bold my-3">
                                {{ $t('partido.entradas_adquiridas_titulo', { entradas: footer.termino_entradas }) }}
                            </p>
                            <br/>
                            <p class="text-bold">
                                👉 {{ $t('partido.entradas_adquiridas', { entradas: footer.termino_entradas }) }}
                            </p>
                            <br/>
                            <p class="text-bold">
                                👉 {{ $t('partido.entradas_adquiridas_spam') }}
                            </p>
                        </div>
                        <div v-else>
                            <p class="h4 text-bold my-3">
                                {{  $t('partido.reservas_adquiridas_titulo', { entradas: footer.termino_entradas }) }}
                            </p>
                            <br/>
                            <p class="text-bold">
                                👉 {{ $t('partido.reservas_adquiridas', { entradas: footer.termino_entradas }) }}
                            </p>
                            <br/>
                            <p class="text-bold">
                                👉 {{ $t('partido.reservas_adquiridas_spam') }}
                            </p>
                        </div>
                        <div v-if="!reserva_instalaciones">
                            <p class="text-bold">👉 {{ $t('partido.entradas_adquiridas_whatsapp', { entradas: footer.termino_entradas }) }}</p>
                            <p class="text-bold">👉 {{ $t('partido.entradas_adquiridas_whatsapp_incluir') }}</p>
                            <p class="text-bold">👉 {{ $t('partido.entradas_adquiridas_whatsapp_minutos') }}</p>
                        </div>
                        <div v-else>
                            <p class="text-bold">👉 {{ $t('partido.reservas_adquiridas_whatsapp', { entradas: footer.termino_entradas }) }}</p>
                            <p class="text-bold">👉 {{ $t('partido.reservas_adquiridas_whatsapp_incluir') }}</p>
                            <p class="text-bold">👉 {{ $t('partido.reservas_adquiridas_whatsapp_minutos') }}</p>
                        </div>
                        <p v-if="solicitar_datos"><b>👉 {{ $t(reserva_instalaciones ? 'partido.reserva_nominativas' : 'partido.entrada_nominativas', { entradas: footer.termino_entradas }) }}</b></p>
                    </div>
                    <div class="col-12" v-if="solicitar_datos && limite_cambiar_datos_entrada && limite_tiempo_cambiar_datos_entrada">
                        <p>
                            <b>{{ $t('partido.limite_tiempo_cambiar_datos', { tiempo: limite_tiempo_cambiar_datos_entrada.nombre }) }}</b>
                        </p>
                    </div>
                </div>

                <template v-if="! solicitar_datos && Array.isArray(asientos)">
                    <div v-for="(asiento, index) in entradasFormatted" :key="index" class="col-12">
                        <div class="form-group-multiselect">
                            <label for="precio">
                                {{ $t((!reserva_instalaciones ? 'formularios.precio_entrada' : 'formularios.precio_reserva'), { index: ++index }) }}
                                <span v-if="!asiento.asiento?.fila == 0 && url.includes('reservas')">- {{ $t('general.sector') }}: {{ asiento.asiento?.zona_nombre }} - {{ $t('general.fila') }}: {{ asiento.asiento?.fila }} - {{ $t('general.butaca') }}: {{ asiento.asiento?.asiento }}</span>
                                <span v-if="asiento.visibilidad_reducida" class="text-danger">
                                    - {{ $t('visibilidad_reducida.nombre') }}
                                </span>
                                <span v-if="asiento.porcentaje_visibilidad" class="text-danger">
                                    : {{ asiento.porcentaje_visibilidad }}%
                                </span>
                            </label>
                            <ValidationProvider
                                :name="'Precio entrada ' + index+1"
                                :rules="'required'"
                                mode="passive"
                                v-slot="{ errors }"
                            >
                                <multiselect
                                    v-if="asiento.asiento"
                                    v-model="asiento.precio"
                                    :show-labels="false"
                                    :options="asiento.precios"
                                    :allow-empty="false"
                                    label="descripcion"
                                    :data-cy="'precio-entrada-' + index+1"
                                    :custom-label="customLabel"
                                    :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                    :disabled="desactivar || asiento.tienePrecio"
                                />
                                <multiselect
                                    v-else
                                    v-model="asiento.precioSeleccionado"
                                    :show-labels="false"
                                    :options="asiento.precios"
                                    :allow-empty="false"
                                    label="descripcion"
                                    :data-cy="'precio-entrada-' + index+1"
                                    :custom-label="customLabel"
                                    :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                    :disabled="desactivar || asiento.tienePrecio"
                                />
                            </ValidationProvider>
                        </div>
                    </div>
                </template>
                <template v-if="solicitar_datos && Array.isArray(asientos)">
                    <div v-for="(asiento, index) in entradasFormatted" class="row" :key="index">
                        <template v-if="!asiento.svg_code">
                            <div class="col-12 subtitle h3 light mb-3 mb-lg-3 mt-lg-5">
                                <template v-if="!asiento.asiento">
                                    {{ getButacaName(asiento) }}
                                </template>
                                <template v-else>
                                    {{ asiento.asiento?.zona_nombre }} -
                                    <template v-if="asiento.asiento?.fila > 0 && asiento.asiento?.asiento > 0">
                                        {{ $t('general.fila') }}: {{ asiento.asiento?.fila }} {{ $t('general.butaca') }}: {{ asiento.asiento?.asiento }}
                                    </template>
                                </template>
                            </div>
                            <MensajeNombresDuplicados v-if="esDuplicado == true"/>
                            <div class="col-12 col-lg-4">
                                <FormInput
                                    :disabled="desactivar"
                                    :label="$t('formularios.nombre')"
                                    :id="'asiento-nombre-' + calcRow(index)"
                                    :data-cy="'asiento-nombre-' + calcRow(index)"
                                    :name="$t('formularios.nombre') + ' de la entrada ' + calcRow(index)"
                                    rules="required"
                                    v-model="asiento.nombre"
                                />
                            </div>
                            <div class="col-12 col-lg-4">
                                <FormInput
                                    :disabled="desactivar"
                                    :label="$t('formularios.apellidos')"
                                    :id="'asiento-apellidos-'+ calcRow(index)"
                                    :data-cy="'asiento-apellidos-'+ calcRow(index)"
                                    :name="$t('formularios.apellidos') + ' de la entrada ' + calcRow(index)"
                                    rules="required" v-model="asiento.apellidos"
                                />
                            </div>
                            <template v-if="teatro.hash != '14wAm2L1Jxx5B3J3xBkH'">
                                <div class="col-12 col-lg-4">
                                    <DocumentoTipo
                                        :id="'tipo-documento-' + calcRow(index)"
                                        :value="asiento.tipoDocumentoSeleccionado.type"
                                        :key="'tipo-doc-' + index + '-' + asiento.tipoDocumentoSeleccionado.type"
                                        :index="calcRow(index)"
                                        :disabled="desactivar"
                                        @input="val => { asiento.tipoDocumentoSeleccionado.type = val; }"
                                    />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <DocumentoValor
                                        :type="asiento.tipoDocumentoSeleccionado.type"
                                        :value="asiento.dni"
                                        :index="calcRow(index)"
                                        :disabled="desactivar"
                                        @input="val => { asiento.dni = val; asiento.tipoDocumentoSeleccionado.value = val; }"
                                    />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <label>{{ $t('formularios.telefono') }}</label>
                                    <PhoneInput
                                        :id="'5' + calcRow(index)"
                                        :dataCy="'asiento-telefono-' + calcRow(index)"
                                        :phone="asiento.telefono ?? null"
                                        :desactivar="desactivar"
                                        :forceValidate="false"
                                        :error_telefono="true"
                                        @setNumber="(number) => asiento.telefono = number"
                                        @validNumber="(valid) => {
                                            isValidNumberEntrada = valid
                                        }"
                                    />
                                </div>
                            </template>
                        </template>
                        <template v-else-if="asiento.svg_code">
                            <div v-if="asiento.numero" class="col-12 subtitle h3 light mb-3 mb-lg-3 mt-lg-5">
                                {{ asiento.name }} - N.º: {{ asiento.numero }}
                            </div>
                            <div v-else class="col-12 subtitle h3 light mb-3 mb-lg-3 mt-lg-5">
                                {{ asiento.name }} - {{ $t('general.sector') }}: {{ asiento.sector }} - {{ $t('general.fila') }}: {{ asiento.fila }} - {{ $t('general.butaca') }}: {{ asiento.butaca }}
                            </div>
                            <MensajeNombresDuplicados v-if="esDuplicado == true"/>
                            <div class="col-12 col-lg-4">
                                <FormInput
                                    :disabled="desactivar"
                                    :label="$t('formularios.nombre')"
                                    :id="'asiento-nombre-' + calcRow(index)"
                                    :data-cy="'asiento-nombre-' + calcRow(index)"
                                    :name="$t('formularios.nombre') + ' de la entrada ' + calcRow(index)"
                                    rules="required" v-model="asiento.nombre"
                                />
                            </div>
                            <div class="col-12 col-lg-4">
                                <FormInput
                                    :disabled="desactivar"
                                    :label="$t('formularios.apellidos')"
                                    :id="'asiento-apellidos-' + calcRow(index)"
                                    :data-cy="'asiento-apellidos-' + calcRow(index)"
                                    :name="$t('formularios.apellidos') + ' de la entrada ' + calcRow(index)"
                                    rules="required"
                                    v-model="asiento.apellidos"
                                />
                            </div>
                            <template v-if="teatro.hash != '14wAm2L1Jxx5B3J3xBkH'">
                                <div class="col-12 col-lg-4">
                                    <DocumentoTipo
                                        :id="'tipo-documento-' + calcRow(index)"
                                        :data-cy="'tipo-documento-' + calcRow(index)"
                                        :value="asiento.tipoDocumentoSeleccionado.type"
                                        :key="'tipo-doc-' + index + '-' + asiento.tipoDocumentoSeleccionado.type"
                                        :index="calcRow(index)"
                                        @input="val => { asiento.tipoDocumentoSeleccionado.type = val; }"
                                    />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <DocumentoValor
                                        :type="asiento.tipoDocumentoSeleccionado.type"
                                        :value="asiento.dni"
                                        :index="calcRow(index)"
                                        @input="val => { asiento.dni = val; }"
                                    />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <label>{{ $t('formularios.telefono') }}</label>
                                    <PhoneInput
                                        :id="'asiento-telefono-' + calcRow(index)"
                                        :dataCy="'asiento-telefono-' + calcRow(index)"
                                        :phone="asiento.telefono ?? null"
                                        :desactivar="desactivar"
                                        :forceValidate="false"
                                        :error_telefono="true"
                                        @setNumber="(number) => asiento.telefono = number"
                                        @validNumber="(valid) => {
                                            isValidNumberEntrada = valid
                                        }"
                                    />
                                </div>
                            </template>
                        </template>
                        <div class="col-12" v-if="! lfp">
                            <div class="form-group">
                                <label for="precio">{{ $t((!reserva_instalaciones ? 'formularios.precio_entrada' : 'formularios.precio_reserva'), { index: ++index }) }}</label>
                                <ValidationProvider
                                    :name="'Precio entrada ' + calcRow(index)"
                                    :rules="'required'"
                                    mode="passive"
                                    v-slot="{ errors }"
                                >
                                    <multiselect
                                        v-if="asiento.asiento"
                                        v-model="asiento.precio"
                                        :show-labels="false"
                                        :data-cy="'precio-entrada-' + calcRow(index)"
                                        :options="asiento.precios"
                                        :allow-empty="false"
                                        label="descripcion"
                                        :custom-label="customLabel"
                                        :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                        :disabled="desactivar || asiento.tienePrecio"
                                    />
                                    <multiselect
                                        v-else
                                        v-model="asiento.precioSeleccionado"
                                        :data-cy="'precio-entrada-' + calcRow(index)"
                                        :show-labels="false"
                                        :options="asiento.precios"
                                        :allow-empty="false"
                                        label="descripcion"
                                        :custom-label="customLabel"
                                        :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                        :disabled="desactivar || asiento.tienePrecio"
                                    />
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>
                </template>
                <DatosProductosComponent v-if="Array.isArray(productos) && productos.length > 0" :productos="productos" />
                <template v-if="solicitar_datos && Array.isArray(entradas)">
                    <div v-for="(entrada, index) in array_entradas" class="row mb-3" :key="index">
                        <div class="col-12 subtitle h3 light mb-3 mb-lg-3 mt-lg-5">
                            {{ calcRow(index) + ' - ' + entrada.name }}
                        </div>
                        <MensajeNombresDuplicados v-if="esDuplicado == true"/>
                        <div class="col-12 col-lg-4">
                            <FormInput :disabled="desactivar" :label="$t('formularios.nombre')" :name="$t('formularios.nombre') + ' de la entrada ' + calcRow(index)" rules="required" v-model="entrada.nombre" />
                        </div>
                        <div class="col-12 col-lg-4">
                            <FormInput :disabled="desactivar" :label="$t('formularios.apellidos')" :name="$t('formularios.apellidos') + ' de la entrada ' + calcRow(index)" rules="required" v-model="entrada.apellidos" />
                        </div>
                        <template v-if="teatro.hash != '14wAm2L1Jxx5B3J3xBkH'">
                            <div class="col-12 col-lg-4">
                                <label>{{ $t('formularios.telefono') }}</label>
                                <PhoneInput
                                    :id="'asiento-telefono-' + calcRow(index)"
                                    :dataCy="'asiento-telefono-' + calcRow(index)"
                                    :phone="entrada.telefono ?? null"
                                    :desactivar="desactivar"
                                    :forceValidate="true"
                                    :error_telefono="true"
                                    @setNumber="(number) => entrada.telefono = number"
                                    @validNumber="(valid) => isValidNumberEntrada = valid"
                                />
                            </div>
                        </template>
                        <div v-if="teatro.seguro_entradas_activo" class="col-12 col-lg-4">
                            <DocumentoTipo
                                :value="entrada.tipoDocumentoSeleccionado.type"
                                :key="'tipo-doc-' + index + '-' + entrada.tipoDocumentoSeleccionado.type"
                                :index="calcRow(index)"
                                @input="val => { entrada.tipoDocumentoSeleccionado.type = val; }"
                                :disabled="desactivar"
                            />
                        </div>
                        <div v-if="teatro.seguro_entradas_activo" class="col-12 col-lg-4">
                            <DocumentoValor
                                :type="entrada.tipoDocumentoSeleccionado.type"
                                :value="entrada.dni"
                                :index="calcRow(index)"
                                @input="val => { entrada.dni = val; entrada.tipoDocumentoSeleccionado.value = val; }"
                                :disabled="desactivar"
                            />
                        </div>
                    </div>
                </template>
                <Button
                    id="compra-responsive"
                    data-cy="compra-responsive"
                    type="submit"
                    :label="$t('partido.continuar')"
                    :disabled="desactivar || loading"
                    custom-class="mr-2"
                />

                <Button
                    id="atras"
                    type="button"
                    :label="$t('formularios.atras')"
                    :disabled="desactivar"
                    @click="cambiarAsiento()"
                />
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import MensajeNombresDuplicados from './components/MensajeNombresDuplicados.vue';
    import { isMobileOnly, isTablet, isBrowser } from 'mobile-device-detect';
    import FieldComponent from '@/components/common/FieldComponent';
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import DatosProductosComponent from './components/productos/DatosProductosComponent.vue';
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";
    import Button from '@/modules/ui/Button.vue';
    import DateInput from "@/modules/ui/DateInput";

    export default {
        props: [
            'datos_compradores', 'generos', 'solicitar_datos', 'productos', 'asientos', 'entradas', 'loading',
            'lfp', 'desactivar', 'plazas', 'limite_cambiar_datos_entrada', 'limite_tiempo_cambiar_datos_entrada',
            'fields', 'errors', 'reserva_instalaciones', 'event'
        ],
        data() {
            return {
                esDuplicado: false,
                datos_guardados: false,
                isValidNumber: false,
                isValidNumberEntrada: true,
                localDatosCompradores: this.datos_compradores,
                disabledEmailPreventa: false,
                array_entradas: [],
                tiposDocumento: [
                    { type: "DNI", value: "" },
                    { type: "NIE", value: "" },
                    { type: "NIF", value: "" },
                    { type: "PASAPORTE", value: "" },
                    { type: "OTROS", value: "" }
                ]
            }
        },
        mounted() {
            this.$refs.observer2.reset();
        },
        created() {
            this.localDatosCompradores.tipoDocumentoSeleccionado = this.tiposDocumento.find(tipo => tipo.type === 'DNI');

            if (!this.localDatosCompradores.email_confirmation && this.localDatosCompradores.email) {
                this.localDatosCompradores.email_confirmation = this.localDatosCompradores.email;
            }

            this.setEmail();

            if (this.asientos && Array.isArray(this.asientos)) {
                this.asientos.forEach((asiento, index) => {
                    if (!asiento.tipoDocumentoSeleccionado) {
                        this.$set(asiento, 'tipoDocumentoSeleccionado', { ...this.tiposDocumento.find(tipo => tipo.type === 'DNI') });
                    }

                    if (index === 0) {
                        asiento.nombre = this.localDatosCompradores.nombre;
                        asiento.apellidos = this.localDatosCompradores.apellidos;
                        asiento.dni = this.localDatosCompradores.dni;
                        asiento.telefono = this.localDatosCompradores.telefono;
                    } else {
                        asiento.nombre = '';
                        asiento.apellidos = '';
                        asiento.dni = '';
                        asiento.telefono = null;
                    }
                });
            }

            if (this.plazas && Array.isArray(this.plazas)) {
                this.plazas.forEach(plaza => {
                    if (plaza.precios && plaza.precios.length === 1 && !plaza.precioSeleccionado) {
                        this.$set(plaza, 'precioSeleccionado', plaza.precios[0]);
                    }
                });
            }

            if (this.plazas && Array.isArray(this.plazas)) {
                this.plazas.forEach(plaza => {
                    if (plaza.precios && plaza.precios.length === 1 && !plaza.precioSeleccionado) {
                        this.$set(plaza, 'precioSeleccionado', plaza.precios[0]);
                    }
                });
            }

            if (this.fields && this.fields.length > 0) {
                this.localDatosCompradores.properties = {};
                this.fields.forEach(field => {
                    this.localDatosCompradores.properties[field.name] = '';
                });
            }
            this.añadirDispositivo();

            if (this.url.includes('reservas')) {
                if (this.asientos) {
                    this.asientos.forEach(asiento => {
                        if (!asiento.precioSeleccionado)
                            asiento.precioSeleccionado = asiento.precio;

                        if (asiento.precio || asiento.precioSeleccionado) {
                            asiento.tienePrecio = true;
                        } else {
                            asiento.tienePrecio = false;
                        }
                    })
                }

                if (this.plazas) {
                    this.plazas.forEach(plaza => {
                        if (!plaza.precioSeleccionado)
                            plaza.precioSeleccionado = plaza.precio;

                        if (plaza.precio || plaza.precioSeleccionado) {
                            plaza.tienePrecio = true;
                        } else {
                            plaza.tienePrecio = false;
                        }
                    })
                }
            }

            if (this.entradas && Array.isArray(this.entradas)) {
                this.buildArrayEntradas();
            }
        },
        computed: {
            footer() {
                return this.$store.getters.getFooter;
            },
            entradasFormatted() {
                if (this.plazas) {
                    this.plazas.forEach(plaza => {
                        if (!plaza.tipoDocumentoSeleccionado) {
                            this.$set(plaza, 'tipoDocumentoSeleccionado', { ...this.tiposDocumento.find(tipo => tipo.type === 'DNI') });
                        }
                    });
                }

                if (this.asientos && this.plazas) {
                    return [...this.asientos].concat(...this.plazas);
                } else if (this.asientos && !this.plazas) {
                    return this.asientos;
                } else {
                    return this.plazas;
                }
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            url() {
                return window.location.href;
            },
            user() {
                return this.$store.getters.getUser;
            }
        },
        methods: {
            customLabel({ descripcion, precio }) {
                return `${descripcion} – ${precio}€`
            },
            terminar() {
                this.setEmail();
                this.$emit('terminar', this.array_entradas, this.localDatosCompradores);
                this.datos_guardados = true;
            },
            /**
             * Normaliza un string y lo devuelve en minúsculas sin acentos para
             * comparaciones insensibles a mayúsculas/acentos.
             */
            normalizar(texto) {
                return texto.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, "");
            },
            checkDuplicado() {
                this.esDuplicado = false;
                const seenDnis = new Set();
                const seenNames = new Set();

                const esDuplicado = entry => {
                    // Check DNI
                    if (entry.dni) {
                        const normalized = this.normalizar(entry.dni);
                        if (seenDnis.has(normalized)) return true;
                        seenDnis.add(normalized);
                    }
                    // Check nombre + apellidos
                    if (entry.nombre && entry.apellidos) {
                        const nameKey = `${this.normalizar(entry.nombre)}|${this.normalizar(entry.apellidos)}`;
                        if (seenNames.has(nameKey)) return true;
                        seenNames.add(nameKey);
                    }
                    return false;
                };

                // Check seated entries (asientos + plazas)
                const allSeats = [];
                if (Array.isArray(this.asientos)) allSeats.push(...this.asientos);
                if (Array.isArray(this.plazas)) allSeats.push(...this.plazas);
                for (const entry of allSeats) {
                    if (esDuplicado(entry)) {
                        this.esDuplicado = true;
                        return;
                    }
                }

                // Check quantity-based entries (sin recinto)
                if (Array.isArray(this.array_entradas)) {
                    for (const entry of this.array_entradas) {
                        if (esDuplicado(entry)) {
                            this.esDuplicado = true;
                            return;
                        }
                    }
                }
            },
            async submit() {
                const isValid = await this.$refs.observer2.validate();
                if (this.solicitar_datos) {
                    this.checkDuplicado();
                }
                if (this.esDuplicado == false) {
                    if(isValid && this.isValidNumber && this.isValidNumberEntrada) {
                        this.terminar();
                    } else {
                        this.$nextTick(function() {
                            this.$scrollTo('.is-invalid', 100)
                        });
                    }
                }
            },
            calcRow(index) {
                return ++index;
            },
            cambiarAsiento() {
                if (this.plazas && this.plazas.length > 0) {
                    this.$emit('cambiar-asiento', true);
                } else {
                    this.$emit('cambiar-asiento', false);
                }
                if(!this.event?.tiene_productos){
                    this.borrarSesion();
                }
            },
            borrarSesion() {
                if (sessionStorage.getItem('session_id')) {
                    const params = {
                        session_id: sessionStorage.getItem('session_id'),
                        filters: {
                            session_id: sessionStorage.getItem('session_id'),
                            tid: this.configuracion.hash_teatro
                        },
                        tid: this.configuracion.hash_teatro,
                    };

                    this.$store.dispatch(this.config.getVuexAlias('front.borrar.sesion'), params).then(res => {
                    });

                    sessionStorage.removeItem('session_id');
                }
            },
            añadirDispositivo() {
                if (isMobileOnly) this.localDatosCompradores.dispositivo = 0;
                if (isTablet) this.localDatosCompradores.dispositivo = 1;
                if (isBrowser) this.localDatosCompradores.dispositivo = 2;
            },
            setEmail() {
                if (this.user && this.event?.preventa?.venta_preventa_activa) {
                    this.localDatosCompradores.email = this.user.email;
                    this.localDatosCompradores.email_confirmation = this.user.email;
                    this.disabledEmailPreventa = true;
                }
            },
            buildArrayEntradas() {
                if (!Array.isArray(this.entradas)) return;
                const previousArray = Array.isArray(this.array_entradas) ? this.array_entradas : [];
                const defaultTipo = this.tiposDocumento
                    ? this.tiposDocumento.find(tipo => tipo.type === 'DNI')
                    : null;
                const newArray = [];
                let globalIndex = 0;
                for (let i = 0; i < this.entradas.length; i++) {
                    const entrada = this.entradas[i];
                    for (let j = 0; j < entrada.unidades; j++) {
                        const previous = previousArray[globalIndex];
                        if (previous) {
                            newArray.push({
                                ...previous,
                                name: entrada.name
                            });
                        } else {
                            newArray.push({
                                name: entrada.name,
                                nombre: '',
                                apellidos: '',
                                telefono: null,
                                dni: '',
                                tipoDocumentoSeleccionado: defaultTipo
                                    ? {
                                        type: defaultTipo.type,
                                        value: defaultTipo.value
                                    }
                                    : null
                            });
                        }
                        globalIndex++;
                    }
                }
                this.array_entradas = newArray;
            },
            getButacaName(plaza) {
                if (!plaza.butaca) {
                    return `${this.$t('general.butaca')}: ${plaza.name}`;
                } else {
                    const nButaca = plaza.butaca;
                    const nFila = plaza.fila;
                    const sector = plaza.sector_name;
                    let name = '';

                    if(sector) {
                        name += `${this.$t('general.sector')}: ${sector} - `;
                    }

                    return name += `${this.$t('general.fila')}: ${nFila} - ${this.$t('general.butaca')}: ${nButaca}`
                }
            },

        },
        watch: {
            entradas: {
                handler(newVal) {
                    if (newVal && Array.isArray(newVal)) {
                        this.buildArrayEntradas();
                    }
                },
            },
        },
        components: {
            MensajeNombresDuplicados, FieldComponent, PhoneInput, DatosProductosComponent,
            DocumentoTipo, DocumentoValor, Button, DateInput
        }
    }
</script>

<style scoped>
    .form-group-multiselect {
        margin-left: -1em;
        margin-bottom: 1em;
    }
    .multiselect > .multiselect__tags {
        background-color: white;
        border: none;
    }

    .multiselect > .multiselect__content-wrapper {
        right: 0;
    }

    .multiselect {
        border-bottom: 1px solid black;
        border-radius: 0;
        width: 95.6%;
        height: 10%;
    }

    @media (max-width: 992px) {
        .multiselect {
            width: 97.2%;
        }
    }

</style>
